export default "__VITE_ASSET__Dcnx4XXF__"